import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { indicazioni, rigaVisita } from '../../utils/visite';
import { adessoRoma, chiedeEsito } from '../../utils/percorso';
import { Sposta } from './CardOggi';
import Icona from './Icone';
import { useTraduzioni } from '../../i18n';

// La visita sulla card dell'immobile del cliente (lista /immobili e home): "Visita sabato 19 · 10:30 con Karolina"
// con Indicazioni e Sposta (una richiesta al consulente: annullare lo fa lo staff); dopo, "Visitato il … · esito".
// adesso avanza da solo nelle pagine che lo passano: passata l'ora, Indicazioni e Sposta spariscono.
// Fuori dalla home, "Diteci com'è andata" porta alla home solo se lì c'è davvero la card "Com'è andata?" (stessa
// regola: chiedeEsito di utils/percorso.js; visite = l'elenco completo, per le richieste di spostamento aperte).
// onRifiuto(messaggio): "Sposta" rifiutato dal server (visita annullata o già passata) → la pagina rilegge i dati.
const RigaVisitaCliente = ({ immobile, consulente, onFatto, onRifiuto, adesso = adessoRoma(), inHome = false, visite = null }) => {
  const { t, l } = useTraduzioni();
  const [sposta, setSposta] = useState(false);
  const [chiesto, setChiesto] = useState(false);
  const riga = rigaVisita(immobile, true, adesso, visite, l);
  if (!riga) return null;
  const richiesta = chiesto || riga.visita.spostamento_richiesto;
  const piena = (visite || []).find((v) => v.id === riga.visita.id);
  const perLaRegola = piena || {
    data_visita: String(riga.visita.data_visita || '').slice(0, 19), esito_visita: riga.visita.esito, spostamento_richiesto: riga.visita.spostamento_richiesto,
  };
  const daChiedere = riga.attesaEsito && !inHome && chiedeEsito(perLaRegola, adesso);
  return (
    <div className={`riga-visita ${riga.tipo}`} data-testid="riga-visita">
      <Icona nome={riga.tipo === 'prossima' ? 'calendario' : riga.tipo === 'attesa' ? 'orologio' : 'si'} /><b>{riga.testo}</b>
      {riga.tipo === 'prossima' && (
        <span className="az">
          <a href={indicazioni(immobile)} target="_blank" rel="noopener noreferrer">{t('comune.indicazioni')}</a>
          <button type="button" className="link" onClick={() => setSposta(!sposta)} disabled={richiesta} aria-expanded={sposta}>
            {t(richiesta ? 'comune.spostamento_chiesto' : 'comune.sposta')}
          </button>
        </span>
      )}
      {daChiedere && (
        <span className="az"><Link to="/dashboard">{t('calendario.diteci')}</Link></span>
      )}
      {riga.tipo === 'prossima' && sposta && !richiesta && (
        <Sposta visita={riga.visita} consulente={consulente || { nome: t('comune.il_consulente') }}
          onRichiesta={() => { setChiesto(true); setSposta(false); if (onFatto) onFatto(); }}
          onRifiuto={(messaggio) => { setSposta(false); if (onRifiuto) onRifiuto(messaggio); else if (onFatto) onFatto(); }} />
      )}
    </div>
  );
};

export default RigaVisitaCliente;
